export interface FotoServiceResult {
    fotoString: string,
    genero: string,
    nombres: string,
    apellidos: string
}

export function VoidFotoServiceResult(): FotoServiceResult {
    return {
        fotoString: '',
        genero: '',
        nombres: '',
        apellidos: ''
    }
}